import SelectField from "../../../components/SelectField";
import Toggle from "../../../components/Toggle";

export default function ConditiiStep({ data, update, toggleField }) {
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
      <p style={{
        fontSize: "14px",
        color: "#8a7e70",
        fontFamily: "'DM Sans', sans-serif",
        lineHeight: 1.6,
        margin: "0 0 4px 0",
        padding: "12px 16px",
        backgroundColor: "#fdfbf7",
        borderRadius: "8px",
        border: "1px solid #e8e0d4",
      }}>
        Selecteaza conditiile care se aplica situatiei tale. Daca nu esti sigur, lasa setarile implicite — sunt conforme cu legislatia in vigoare.
      </p>
      <Toggle label="Utilitati incluse in chirie" description="Chiriasul nu plateste separat apa, gazul, electricitatea si internetul — totul e inclus in chiria lunara" checked={data.utilitatiIncluse} onChange={toggleField("utilitatiIncluse")} />
      <Toggle label="Animale de companie permise" description="Chiriasul are dreptul sa detina animale de companie in locuinta (caini, pisici etc.)" checked={data.animalePermise} onChange={toggleField("animalePermise")} />
      <Toggle label="Fumat permis" description="Chiriasul poate fuma in interiorul locuintei. Daca e dezactivat, fumatul e permis doar in exterior" checked={data.fumatPermis} onChange={toggleField("fumatPermis")} />
      <Toggle label="Subinchiriere permisa" description="Chiriasul poate da mai departe locuinta (sau o parte din ea) unei alte persoane, cu sau fara acordul proprietarului" checked={data.subinchirierePermisa} onChange={toggleField("subinchirierePermisa")} />
      <Toggle label="Pierdere garantie la plecare anticipata" description="Daca chiriasul pleaca inainte de expirarea contractului, pierde depozitul de garantie platit la semnare" checked={data.pierdereGarantie} onChange={toggleField("pierdereGarantie")} />
      <div style={{ marginTop: "8px", display: "flex", flexWrap: "wrap", gap: "16px" }}>
        <SelectField
          label="Preaviz reziliere (zile)"
          value={data.notificareZile}
          onChange={update("notificareZile")}
          options={[
            { value: "15", label: "15 zile" },
            { value: "30", label: "30 zile" },
            { value: "60", label: "60 zile" },
            { value: "90", label: "90 zile" },
          ]}
          half
        />
        <SelectField
          label="Dupa cate zile de neplata se poate rezilia automat"
          value={data.zileNeplatReziliere}
          onChange={update("zileNeplatReziliere")}
          options={[
            { value: "30", label: "30 zile" },
            { value: "45", label: "45 zile" },
            { value: "60", label: "60 zile" },
            { value: "90", label: "90 zile" },
          ]}
          half
        />
      </div>
    </div>
  );
}
